import { useNavigate } from "react-router-dom";
import { Package, ShoppingCart, Lock, ArrowRight, ListTodo, Scissors, ShieldCheck, Shirt, Barcode, Megaphone, Users, Building2, UserPlus, Warehouse, ShoppingBag, ClipboardList, HardDrive } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function ModuleSelection() {
  const navigate = useNavigate();
  const username = localStorage.getItem("username") || "User";

  const modules = [
    {
      id: "packflow",
      name: "PackFlow",
      description: "Packing & Dispatch Management",
      icon: Package,
      color: "from-blue-500 to-blue-700",
      bgColor: "bg-blue-600",
      lightBg: "bg-blue-50",
      borderColor: "border-blue-200",
      path: "/packflow",
      features: ["Purchase Orders", "Packing Lists & Cartons", "Barcode Scanning", "Carton Labels"]
    },
    {
      id: "purchase",
      name: "Purchase",
      description: "Raw Material Procurement",
      icon: ShoppingCart,
      color: "from-green-500 to-green-700",
      bgColor: "bg-green-600",
      lightBg: "bg-green-50",
      borderColor: "border-green-200",
      path: "/purchase",
      features: ["Buyer Orders", "Bill of Materials", "Vendor Management", "GRN Reports"]
    },
    {
      id: "marketing",
      name: "Marketing",
      description: "Buyers & Business Development",
      icon: Megaphone,
      color: "from-rose-500 to-rose-700",
      bgColor: "bg-rose-600",
      lightBg: "bg-rose-50",
      borderColor: "border-rose-200",
      path: "/marketing",
      features: ["Current Buyers", "Prospective Buyers", "Company Profile", "Email Documents"]
    },
    {
      id: "accounts",
      name: "Accounts",
      description: "Financial Compliance & Checklist",
      icon: ListTodo,
      color: "from-cyan-500 to-cyan-700",
      bgColor: "bg-cyan-600",
      lightBg: "bg-cyan-50",
      borderColor: "border-cyan-200",
      path: "/accounts",
      features: ["Daily Tasks", "Weekly Tasks", "Monthly Tasks", "Compliance Tracking"]
    },
    {
      id: "store",
      name: "Fabric Store",
      description: "Fabric & Trim Inventory",
      icon: Warehouse,
      color: "from-amber-500 to-amber-700",
      bgColor: "bg-amber-600",
      lightBg: "bg-amber-50",
      borderColor: "border-amber-200",
      path: "/store",
      features: ["GRN Integration", "Barcode Labels", "Location Tracking", "Stock Management"]
    },
    {
      id: "delegation",
      name: "Delegation",
      description: "Task Assignment & Tracking",
      icon: ListTodo,
      color: "from-purple-500 to-purple-700",
      bgColor: "bg-purple-600",
      lightBg: "bg-purple-50",
      borderColor: "border-purple-200",
      path: "/delegation",
      features: ["Task Management", "Staff Directory", "Priority & Due Dates", "Notifications"]
    },
    {
      id: "cutting",
      name: "Cutting",
      description: "Cutting Issue & Receive",
      icon: Scissors,
      color: "from-orange-500 to-orange-700",
      bgColor: "bg-orange-600",
      lightBg: "bg-orange-50",
      borderColor: "border-orange-200",
      path: "/cutting",
      features: ["Cutting Orders", "Issue to Tailors", "Receive Stitching", "Payment Management"]
    },
    {
      id: "productivity",
      name: "Productivity",
      description: "Worker Management & Productivity Tracking",
      icon: Users,
      color: "from-indigo-500 to-indigo-700",
      bgColor: "bg-indigo-600",
      lightBg: "bg-indigo-50",
      borderColor: "border-indigo-200",
      path: "/productivity",
      features: ["Worker Management", "Attendance", "Cutting Issue", "Challans", "Groups"]
    },
    {
      id: "quality",
      name: "Quality",
      description: "Production Quality Review",
      icon: ShieldCheck,
      color: "from-teal-500 to-teal-700",
      bgColor: "bg-teal-600",
      lightBg: "bg-teal-50",
      borderColor: "border-teal-200",
      path: "/quality",
      features: ["PP Sample Review", "Size & Measurement", "Final Checking", "Pre-Inspection"]
    },
    {
      id: "sampling",
      name: "Sampling",
      description: "Sample Development & Tracking",
      icon: Shirt,
      color: "from-pink-500 to-pink-700",
      bgColor: "bg-pink-600",
      lightBg: "bg-pink-50",
      borderColor: "border-pink-200",
      path: "/sampling",
      features: ["Sample Creation", "Fabric Details", "Costing", "Production Tracking"]
    },
    {
      id: "barcode",
      name: "Barcode",
      description: "Barcode Label Generation",
      icon: Barcode,
      color: "from-indigo-500 to-indigo-700",
      bgColor: "bg-indigo-600",
      lightBg: "bg-indigo-50",
      borderColor: "border-indigo-200",
      path: "/barcode",
      features: ["Generate Barcodes", "Multi-Size Labels", "Custom MRP", "PDF Export"]
    },
    {
      id: "kidsdew",
      name: "Kidsdew",
      description: "In-house Brand Management",
      icon: ShoppingBag,
      color: "from-fuchsia-500 to-fuchsia-700",
      bgColor: "bg-fuchsia-600",
      lightBg: "bg-fuchsia-50",
      borderColor: "border-fuchsia-200",
      path: "/kidsdew",
      features: ["Product Catalog", "Content Library", "Post Creator", "Sales Hub"]
    },
    {
      id: "buyer-sop",
      name: "Buyer SOP",
      description: "Buyer Standard Operating Procedures",
      icon: ClipboardList,
      color: "from-indigo-500 to-violet-700",
      bgColor: "bg-indigo-600",
      lightBg: "bg-indigo-50",
      borderColor: "border-indigo-200",
      path: "/buyer-sop",
      features: ["Buyer Details", "Approved Vendors", "Testing Protocols", "Custom Requirements"]
    },
    {
      id: "worker-scanner",
      name: "Worker Scanner",
      description: "Scan Worker Barcode for Instant Profile",
      icon: Barcode,
      color: "from-sky-500 to-sky-700",
      bgColor: "bg-sky-600",
      lightBg: "bg-sky-50",
      borderColor: "border-sky-200",
      path: "/worker-scanner",
      features: ["Camera / USB Scan", "Issue & Receive Summary", "Productivity", "Payments Breakdown"]
    },
    {
      id: "drive",
      name: "Drive",
      description: "File Storage & Sharing",
      icon: HardDrive,
      color: "from-violet-500 to-violet-700",
      bgColor: "bg-violet-600",
      lightBg: "bg-violet-50",
      borderColor: "border-violet-200",
      path: "/drive",
      features: ["File Upload", "Folder Organization", "Share Links", "Version History"]
    }
  ];

  const handleModuleSelect = (module) => {
    localStorage.setItem("selected_module", module.id);
    navigate(module.path);
  };

  return (
    <div className="min-h-screen bg-zinc-950 flex flex-col">
      {/* Header */}
      <header className="bg-zinc-900/80 backdrop-blur-sm border-b border-zinc-800 px-4 sm:px-8 py-4 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-purple-600 rounded-xl flex items-center justify-center shadow-lg shadow-blue-500/20">
              <Package className="w-5 h-5 text-white" />
            </div>
            <div>
              <h1 className="font-bold text-xl text-white" style={{ fontFamily: 'Manrope, sans-serif' }}>
                ERP for Trela Tex
              </h1>
              <p className="text-xs text-zinc-400">Garment Management System</p>
            </div>
          </div>
          <div className="flex items-center gap-4">
            <span className="text-sm text-zinc-400 hidden sm:inline">
              Welcome, <span className="text-white font-medium">{username}</span>
            </span>
            <Button 
              variant="outline" 
              size="sm"
              className="border-zinc-700 text-zinc-300 hover:bg-zinc-800 hover:text-white"
              onClick={() => {
                localStorage.removeItem("auth_token");
                localStorage.removeItem("username");
                localStorage.removeItem("selected_module");
                window.location.href = "/login";
              }}
            >
              Logout
            </Button>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 p-4 sm:p-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-2xl sm:text-4xl font-bold text-white mb-2" style={{ fontFamily: 'Manrope, sans-serif' }}>
              Select Module
            </h2>
            <p className="text-zinc-400">Choose which module you want to work with</p>
          </div>

          {/* Module Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-5">
            {modules.map((module) => (
              <div
                key={module.id}
                data-testid={`module-card-${module.id}`}
                className="group relative bg-zinc-900/50 backdrop-blur-sm rounded-2xl border border-zinc-800 overflow-hidden hover:border-zinc-700 transition-all duration-300 cursor-pointer hover:shadow-xl hover:shadow-black/20 hover:-translate-y-1"
                onClick={() => handleModuleSelect(module)}
              >
                {/* Gradient Glow Effect */}
                <div className={`absolute inset-0 bg-gradient-to-br ${module.color} opacity-0 group-hover:opacity-10 transition-opacity duration-300`}></div>
                
                {/* Module Content */}
                <div className="relative p-5">
                  {/* Icon and Title */}
                  <div className="flex items-start gap-4 mb-4">
                    <div className={`w-12 h-12 bg-gradient-to-br ${module.color} rounded-xl flex items-center justify-center shadow-lg`}>
                      <module.icon className="w-6 h-6 text-white" />
                    </div>
                    <div className="flex-1">
                      <h3 className="text-lg font-bold text-white" style={{ fontFamily: 'Manrope, sans-serif' }}>
                        {module.name}
                      </h3>
                      <p className="text-xs text-zinc-400">{module.description}</p>
                    </div>
                  </div>

                  {/* Features */}
                  <div className="space-y-1.5 mb-4">
                    {module.features.map((feature, idx) => (
                      <div key={idx} className="flex items-center gap-2 text-xs text-zinc-400">
                        <div className={`w-1 h-1 rounded-full ${module.bgColor}`}></div>
                        {feature}
                      </div>
                    ))}
                  </div>

                  {/* Enter Button */}
                  <button className={`w-full py-2.5 bg-gradient-to-r ${module.color} text-white text-sm font-medium rounded-lg flex items-center justify-center gap-2 opacity-90 group-hover:opacity-100 transition-opacity`}>
                    Enter
                    <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                  </button>
                </div>
              </div>
            ))}
          </div>

          {/* Quick Stats */}
          <div className="mt-12 grid grid-cols-2 sm:grid-cols-4 gap-4">
            <div className="bg-zinc-900/50 rounded-xl p-4 border border-zinc-800">
              <div className="text-2xl font-bold text-white">9</div>
              <div className="text-xs text-zinc-400">Active Modules</div>
            </div>
            <div className="bg-zinc-900/50 rounded-xl p-4 border border-zinc-800">
              <div className="text-2xl font-bold text-green-400">v2.1</div>
              <div className="text-xs text-zinc-400">System Version</div>
            </div>
            <div className="bg-zinc-900/50 rounded-xl p-4 border border-zinc-800">
              <div className="text-2xl font-bold text-blue-400">24/7</div>
              <div className="text-xs text-zinc-400">System Uptime</div>
            </div>
            <div className="bg-zinc-900/50 rounded-xl p-4 border border-zinc-800">
              <div className="text-2xl font-bold text-purple-400">Pro</div>
              <div className="text-xs text-zinc-400">License Type</div>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-zinc-900/50 border-t border-zinc-800 py-4 text-center text-xs text-zinc-500">
        ERP for Trela Tex v2.1.0 | Garment Management System
      </footer>
    </div>
  );
}
